export default __webpack_public_path__ + "static/media/5.5039a0b3.jpg";